import React, { useState, useEffect, useRef } from 'react';
import AppBaseComponent from '../../../components/AppBaseComponent';
import ApplicationLayout from "../../../layouts/ApplicationLayout";
import { useSelector } from "react-redux";
import Ax from "../../../components/hoc/Ax";
import moment from "moment";
import tapIcon from "../../../services/TapIcon";
import HttpAPICall from "../../../services/HttpAPICall";
import Loader from "../../../components/ui/Loader/Loader";
import { PeriodSelectionWithCustom, DisplaySearchCriteria, DisplayListPagination } from "../../../components/TapUi/index";
import TapSelect from "../../../components/ui/TapSelect";
import Helmet from 'react-helmet';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import TapIcon from '../../../services/TapIcon';
import ProductivityComparisonGraph from './ProductivityComparisonPeriodGraph';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import ProgressBarComparison from './ProductivityComparisonPeriodGraph';
import DownloadFile from '../../../services/DownloadFile';
import PageHeader from '../../includes/PageHeader';
import DatePicker from "react-datepicker";
import TapHelper from '../../../services/TapHelper';
import AssetProductivityTargetDetailModal from './AssetProductivityTargetDetailModal';

const AssetProductivityTargetReport = (props) => {
    const access_token = useSelector(state => state.auth.access_token);
    const assetProductivityTargetDetailModalRef = useRef(null);

    const criteriaRef = useRef();
    const user_sites = useSelector(state => state.app.user_sites ? state.app.user_sites.map((s) => { return { value: s.id, label: `${s.site_name} (${s.site_code})` } }) : []);

    const report_listing = useSelector(state => state.app?.report_listing || []);
    const itemListUrl = `${IAM_API_BASE_URL_2}/report/configuration_wise_asset_productivity`;

    const initialListData = {
        loading: false,
        data_loaded: false,
        items: [],
        meta: null,
        page: 1,
    };

    const reportFilterFormInitialState = {
        per_page: 7,
        downloading: false,
        search_asset_ids: [],
        search_site_ids: [],
        search_activity_ids: [],
        search_units: [],
        date_range: moment(new Date()).format("YYYY-MM-DD"),
        show_filter: true
    };

    let reportFilterFormLabel = {
        search_activity_ids: 'Activity : ',
        search_site_ids: 'Sites : ',
        date_range: "Transaction Date : ",
        search_units: "UOM : ",
        search_asset_ids: "Asset : "
    };

    const [reportName, setReportName] = useState({});
    const [showFilterForm, setShowFilterForm] = useState(true);
    const [reportFilterForm, setReportFilterForm] = useState(reportFilterFormInitialState);
    const [formDataLoaded, setFormDataLoaded] = useState(false);
    const [searchedAssets, setSearchAssets] = useState([]);
    const [criteriaHeight, setCriteriaHeight] = useState(0);
    const [allActivitesList, setAllActivitesList] = useState([]);
    const [reportSubmitted, setReportSubmitted] = useState(false);
    const [formSearchedElems, setFormSearchedElems] = useState([]);
    const [listing_loading, setListingLoading] = useState(false);
    const [siteProductivityData, setSiteProductivityData] = useState({ ...initialListData });
    const [allProductionUnitList, setAllProductionUnitList] = useState([]);

    useEffect(() => {
        initilaizeAppDataToFilterForm(props);
        filterFormDataInit();
    }, []);

    const updateCriteriaHeight = () => {
        if (criteriaRef.current) {
            const height = criteriaRef.current.offsetHeight;
            if (criteriaHeight !== height) {
                setCriteriaHeight(height);
            }
        }
    };

    useEffect(() => {
        updateCriteriaHeight();
    }, [formSearchedElems]);

    const filterFormDataInit = () => {
        setFormDataLoaded(true);
        HttpAPICall.withAthorization('GET', itemListUrl, access_token, { action: 'formData' }, {}, (response) => {
            let respData = response.data;
            setAllActivitesList(respData.activity_data.map(td => ({ value: td.id, label: td.activity_name })));
            setAllProductionUnitList(respData.uom.map(td => ({ value: td.id, label: td.measuring_unit })));
        }).then(() => {
            setFormDataLoaded(false);
        });
    };

    const initilaizeAppDataToFilterForm = (props) => {
        const report_name = props?.location?.pathname ? props.location.pathname.split('/')[2] : '';
        const reportData = report_listing.length > 0 ? report_listing.filter(d => d.key === report_name) : [];
        setReportName(reportData.length > 0 ? reportData[0] : null);
    };

    const toggleFilterForm = () => {
        setShowFilterForm(!showFilterForm);
        setReportFilterForm(prev => ({ ...prev, show_filter: !showFilterForm }));

        if (document.getElementById('pageTbl')) {
            document.getElementById('pageTbl').scroll({ top: 0, behavior: 'smooth' });
        }
    };
    const openDetailModal = (item, id) => {
        const dateRange = reportFilterForm.date_range;

        const totalActualProduction = item?.productivity_data.reduce((sum, curr) => (
            sum + parseFloat(curr.actual_production || 0)
        ), 0);

        const configurationDetail = {
            total_actual_productivity: totalActualProduction,
            total_prod_target: item.total_prod_target,
            configuration_name: item.name
        };

        assetProductivityTargetDetailModalRef.current?.initModalHandler(configurationDetail, id, dateRange);
    };
    const closeReport = () => {
        props.history.push('/report');
    };

    const tapSelectChange = (selectedOption, fieldName) => {
        setReportFilterForm((prev) => ({
            ...prev,
            [fieldName]: selectedOption.map(o => o.value),
        }));
    };

    const formDateHandler = (name, value = null) => {
        if (name) {
            const formattedDate = value ? moment(value).format('YYYY-MM-DD') : null;
            setReportFilterForm(prevState => ({
                ...prevState,
                [name]: formattedDate,
            }));
        }
    };

    const loadListingTblData = (page = 1) => {
        setListingLoading(true);
        setSiteProductivityData(prev => ({ ...prev, loading: true }));

        const params = {
            action: 'data',
            page,
            ...reportFilterForm,
            per_page: reportFilterForm.per_page
        };

        HttpAPICall.withAthorization('GET', itemListUrl, access_token, params, {}, (response) => {
            const respData = response.data;
            const meta = {
                from: respData.data.from,
                to: respData.data.to,
                total: respData.data.total,
                last_page: respData.data.last_page,
                per_page: respData.data.per_page,
                current_page: respData.data.current_page
            };

            setSiteProductivityData(prev => ({
                ...prev,
                data_loaded: true,
                loading: false,
                items: respData.data.data,
                meta
            }));
        }).catch(error => {
            console.error("API Error:", error);
            setSiteProductivityData(prev => ({ ...prev, loading: false }));
        }).finally(() => {
            setListingLoading(false);
        });
    };

    const reportFilterFormSubmit = (event = null) => {
        if (event) {
            event.preventDefault();
        }

        let searchFormKeys = Object.keys(reportFilterForm);
        let searchedElems = [];

        searchFormKeys.forEach((key) => {
            let label = reportFilterFormLabel[key];
            let value = reportFilterForm[key];

            if (value && (Array.isArray(value) ? value.length > 0 : value.toString().length > 0)) {
                if (label) {
                    let show_val = value;

                    if (key == 'search_site_ids') {
                        show_val = user_sites.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if (key == 'search_asset_ids') {
                        show_val = searchedAssets ? searchedAssets.map(s => s.display_label).join(', ') : '';
                    }
                    if (key == 'search_activity_ids') {
                        show_val = allActivitesList.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if (key == 'search_units') {
                        show_val = allProductionUnitList.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if (key === 'date_range' && reportFilterForm.date_range) {
                        const formattedDate = moment(reportFilterForm.date_range).format('DD-MMM-YYYY');
                        show_val = formattedDate;
                    }
                    if (show_val) {
                        searchedElems.push(label + `<b>${show_val}</b>`);
                    }
                }
            }
        });

        setFormSearchedElems(searchedElems);
        setReportSubmitted(true);
        setShowFilterForm(false);
        setReportFilterForm(prev => ({ ...prev, show_filter: false }));

        loadListingTblData(1);
    };

  

    const reportDownloadHandler = () => {
        const keysToRemove = ['per_page', 'loading', 'downloading'];
        const params = {
            action: 'download',
            ...reportFilterForm
        };

        keysToRemove.forEach(key => {
            delete params[key];
        });

        setSiteProductivityData(prev => ({
            ...prev,
            downloading: true
        }));

        HttpAPICall.withAthorization('GET', itemListUrl, access_token, params, {}, (response) => {
            if (response.data && response.data.msg) {
                DownloadFile.file(null, response.data.msg, response.data.navigation, props);
            } else {
                console.error("No file data received");
            }
        }).catch(error => {
            console.error("Download error:", error);
        }).finally(() => {
            setSiteProductivityData(prev => ({
                ...prev,
                downloading: false
            }));
        });
    };

    const pageTitleBarJsx = () => {
        return (
            <div className="page_title row m0">
                <div className="col-sm-12">
                    <h3><TapIcon.FontAwesomeIcon icon={TapIcon.faCubes} /> {reportName?.name}</h3>
                    <div className="text-end mt15">
                        <button type="button" onClick={toggleFilterForm} className="btn btn-secondary">
                            {showFilterForm ? 'Change Filter' : 'Change Filter'}
                        </button>
                        {reportSubmitted && (
                            <button
                                type="button"
                                className="btn btn-secondary"
                                disabled={siteProductivityData.downloading || siteProductivityData.loading}
                                onClick={reportDownloadHandler}>
                                <TapIcon.FontAwesomeIcon icon={TapIcon.faDownload} />
                                {siteProductivityData.downloading && (
                                    <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin ms-2" />
                                )}
                            </button>
                        )}
                        <button type="button" className="btn btn-secondary" onClick={closeReport}>
                            <tapIcon.imageIcon icon={tapIcon.CloseIcon} className="img-fluid" alt="item-close" />
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    const reportFilterFormJsx = () => {
        return (
            <div id="reportFilterForm" className="bg-white" style={{ display: showFilterForm ? 'block' : 'none' }}>
                <form onSubmit={reportFilterFormSubmit} className={['p-3', 'filter_form'].join(' ')}>
                    <div className="row mb-3">
                        <label className="col-sm-3 col-form-label col-form-label-sm text-end">Activity Name</label>
                        <div className="col-sm-8">
                            <TapSelect
                                options={allActivitesList}
                                changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'search_activity_ids')}
                                isSearchable={true}
                                isClearable={true}
                                isMulti={true}
                                value={allActivitesList.filter(s => reportFilterForm.search_activity_ids.includes(s.value))}
                                placeholder="Select Activity"
                                containerHeight="30px"
                                fontSize="93%"
                            />
                        </div>
                    </div>

                    <div className='row mb-3'>
                        <label className="col-sm-3 col-form-label col-form-label-sm text-end">UOM</label>
                        <div className="col-sm-8">
                            <TapSelect
                                options={allProductionUnitList}
                                changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'search_units')}
                                isSearchable={true}
                                isClearable={true}
                                isMulti={true}
                                value={allProductionUnitList.filter(s => reportFilterForm.search_units.includes(s.value))}
                                placeholder="Unit of Measurement"
                                containerHeight="30px"
                                fontSize="93%"
                            />
                        </div>
                    </div>


                    <div className="row mb-3">
                        <label className="col-sm-3 col-form-label col-form-label-sm text-end">Site</label>
                        <div className="col-sm-8">
                            <TapSelect
                                options={user_sites ? user_sites : []}
                                changeEvent={(selectedOption) => tapSelectChange(selectedOption, 'search_site_ids')}
                                isSearchable={true}
                                isClearable={true}
                                isMulti={true}
                                value={user_sites.filter(s => reportFilterForm.search_site_ids.includes(s.value))}
                                placeholder="Select Site"
                                containerHeight="30px"
                                fontSize="93%"
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-3 col-form-label col-form-label-sm text-end">Asset</label>
                        <div className="col-sm-8">
                            <InputAssetSearch
                                containerHeight="30px"
                                fontSize="93%"
                                changeEvent={(selectedOption) => {
                                    tapSelectChange(selectedOption, 'search_asset_ids');
                                    setSearchAssets(selectedOption && selectedOption.length > 0 ? selectedOption : []);
                                }}
                                isMulti={true}
                                menuPlacement="top"
                                value={searchedAssets.length > 0 ? searchedAssets.map(a => { a.label = a.display_label; return a; }) : []}
                                placeholder="Search Assets"
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-3 col-form-label col-form-label-sm text-end">Transaction Date</label>
                        <div className="col-sm-8 add_calender_section ">
                            <DatePicker
                                className="form-control form-control-sm"
                                selected={reportFilterForm.date_range ? moment(reportFilterForm.date_range, "YYYY-MM-DD").toDate() : null}
                                onChange={(date) => formDateHandler('date_range', date)}
                                placeholderText='Please Enter Date'
                                dateFormat="dd-MMM-yyyy"
                                maxDate={moment(new Date(), 'YYYY-MM-DD').toDate()}
                            />
                            <TapIcon.imageIcon icon={TapIcon.CalenderIcon} className="add_calender-icon" style={{ top: "4px" }} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="pb-3 col-9 text-end">
                            <button type="submit" disabled={listing_loading} className="btn btn-primary px-4">
                                Show Report
                            </button>
                        </div>
                        <hr />
                    </div>
                </form>
            </div>
        );
    };

    const reportListingDisplayJsx = () => (
        <>
            <div ref={criteriaRef}
                style={{
                    position: 'sticky',
                    top: 0,
                    background: 'white',
                }}>
                <DisplaySearchCriteria searchedElems={formSearchedElems} />
            </div>

                <table className="table table-sm table-bordered align-middle bg-white table-hover">
                    <thead className="table-secondary text-center"
                        style={{
                            top: `${criteriaHeight}px`,
                            position: 'sticky',
                        }}>
                        <tr>
                            <th style={{ width: "15%" }}>Configuration Name</th>
                            <th style={{ width: "15%" }}>Site Name</th>
                            <th style={{ width: "20%" }}>Asset Name</th>
                            <th style={{ width: "10%" }}>Activity</th>
                            <th style={{ width: "10%" }}>UOM</th>
                            <th style={{ width: "10%" }}>Shift</th>
                            <th style={{ width: "10%" }}>Actual</th>
                            <th style={{ width: "10%" }}>Total Actual</th>
                        </tr>
                    </thead>
                    <tbody>
                        {siteProductivityData.loading ? (
                            <tr>
                                <td colSpan={8} className="text-center"><Loader /></td>
                            </tr>
                        ) : siteProductivityData.items.length > 0 ? (
                            siteProductivityData.items.map((item, index) =>
                                item.productivity_data && item.productivity_data.length > 0 ? (
                                    item.productivity_data.map((data, dataIndex) => (
                                        <tr key={`${index}-${dataIndex}`}>
                                            {dataIndex === 0 && (
                                                <td rowSpan={item.productivity_data.length} className="text-center align-middle">
                                                    <span className="link-primary cursor_pointer"
                                                        onClick={() => openDetailModal(item, item.id)}>
                                                        {item.name || "-"}
                                                    </span>
                                                </td>
                                            )}
                                            <td className="text-center">{data.site || "-"}</td>
                                            <td className="text-center">{data.asset || "-"}</td>
                                            <td className="text-center">{data.activity || "-"}</td>
                                            <td className="text-center">{data.unit || "-"}</td>
                                            <td className="text-center">{data.shift || "-"}</td>
                                            <td className="text-center">{data.actual_production || "-"}</td>
                                            {dataIndex === 0 && (
                                                <td rowSpan={item.productivity_data.length} className="text-end">
                                                    {TapHelper.numberFormatter(
                                                        item.productivity_data.reduce(
                                                            (sum, curr) => sum + parseFloat(curr.actual_production || 0),
                                                            0
                                                        ),
                                                        2
                                                    )}
                                                </td>
                                            )}
                                        </tr>
                                    ))
                                ) : (
                                    <tr key={`no-records-${index}`}>
                                        <td className="text-center align-middle">
                                            <span className="link-primary cursor_pointer"
                                                onClick={() => openDetailModal(item, item.id)}>
                                                {item.name || "-"}
                                            </span>
                                        </td>
                                        <td className="text-center">-</td>
                                        <td className="text-center">-</td>
                                        <td className="text-center">-</td>
                                        <td className="text-center">-</td>
                                        <td className="text-center">-</td>
                                        <td className="text-center">-</td>
                                        <td className="text-center">-</td>
                                    </tr>
                                )
                            )
                        ) : (
                            <tr>
                                <td colSpan={8} className="text-center">No Records Found</td>
                            </tr>
                        )}
                    </tbody>
                </table>

            <DisplayListPagination
                meta={siteProductivityData.meta}
                onPageChange={e => loadListingTblData(e.selected + 1)}
            />
        </>
    );

    return (
        <ApplicationLayout>
            <Helmet><title>Productivity Period Comparison - Report</title></Helmet>
            {pageTitleBarJsx()}
            <div className="container-fluid pl5">
                <div className="page_containt row">
                    <div id="pageTbl" className="pageTbl col-12 pb-2">
                        {formDataLoaded ? <Loader /> : reportFilterFormJsx()}

                        {reportSubmitted && (
                            <>
                                {reportListingDisplayJsx()}
                            </>
                        )}
                    </div>
                </div>
            </div>
            <AssetProductivityTargetDetailModal ref={assetProductivityTargetDetailModalRef} />
        </ApplicationLayout>
    );
};

export default AssetProductivityTargetReport;